import Store from "@/store";
import axios from "axios";

const API_HOST = process.env.VUE_APP_API_HOST;

// Create axios instance
const axiosSetting = {
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
};

// definition axios wrapper
class AxiosWrapper {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }

    async get(url, config) {
        try {
            const res = await this.axiosInstance.get(url, config);
            return res.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async post(url, data, config) {
        try {
            const res = await this.axiosInstance.post(url, data, config);
            return res.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async put(url, data, config) {
        try {
            const res = await this.axiosInstance.put(url, data, config);
            return res.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    async delete(url, config) {
        try {
            const res = await this.axiosInstance.delete(url, config);
            return res.data;
        } catch (error) {
            this.handleError(error);
        }
    }

    handleError(error) {
        console.log(error);
        Store.commit("popup/message/show", {
            title: "오류",
            message: error.message,
        });

        throw error;
    }
}

export const client = new AxiosWrapper(
    axios.create({ ...axiosSetting, baseURL: API_HOST })
);